import apiClient from '@/services/axios'

export const getGoodsReceipt = (params) => {
  return apiClient({
    method: 'get',
    url: '/goodreceive/query/good-receive',
    params,
  })
}

export const createGoodsReceipt = ({ param, data }) => {
  const path = param === 'simple_wms' ? '/wms' : ''
  return apiClient({
    method: 'post',
    url: `/goodreceive/cmd${path}/save`,
    data,
  })
}

export const getDetailGoodsReceipt = ({ business_id, id }) => {
  return apiClient({
    method: 'get',
    url: `/goodreceive/query/good-receive/${id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getDetailGoodsReceiptByInbound = ({ business_id, number }) => {
  return apiClient({
    method: 'get',
    url: '/goodreceive/query/good-receive/inbound',
    headers: {
      'Business-Id': business_id,
    },
    params: { inbound_reference: number },
  })
}

export const getBulkGoodsReceiptProcess = ({ business_id, request_id }) => {
  return apiClient({
    method: 'get',
    url: `/goodreceive/cmd/api/gr/process/${request_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const downloadBulkGoodsReceiptTemplate = (business_id) => {
  return apiClient({
    method: 'get',
    responseType: 'blob',
    url: '/goodreceive/cmd/api/gr/download-template',
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const downloadFailedBulkGoodsReceipt = ({ business_id, request_id }) => {
  return apiClient({
    method: 'get',
    responseType: 'blob',
    url: `/goodreceive/cmd/api/gr/download/${request_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const uploadBulkGoodsReceipt = ({ business_id, file }) => {
  const form = new FormData()
  form.append('file', file)

  return apiClient({
    method: 'post',
    url: '/goodreceive/cmd/api/gr/upload',
    headers: {
      'Business-Id': business_id,
    },
    data: form,
  })
}